import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class UserFormGuard implements CanActivate {

  constructor( private permissionService: PermissionService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.permissionService.permissions$.pipe(
      map( permissions => {
        let canEditUser = permissions.canEditUser;
        if (!canEditUser) {
          return this.router.parseUrl('admin');
        } 
        return true;
      }),
    );
  }
  
}
